<template lang='pug'>
  i.svg-icon.svg-icon-flash
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100')
      path(d="M78,60.93c-21.18,3.68-33.56,15.95-37.15,37.14C37.24,76.9,24.87,64.61,3.83,60.92c21.01-3.55,33.36-15.92,37.01-37 C44.43,44.95,56.81,57.31,78,60.93z")
      path(d="M77.53,14.48C79.62,25.57,86,31.86,97,34c-10.95,2.11-17.37,8.41-19.46,19.53C75.42,42.5,69.1,36.1,57.99,34.02 C69.05,31.91,75.43,25.57,77.53,14.48z")

</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
}
</script>